import { SavedChart } from "interfaces/chart";
import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";

interface LazyFetchChart {
  loading: boolean;
  error: boolean;
  fetchCallback: (url: string) => Promise<SavedChart>;
}

/** Gets a specific chart from the API when an id is provided */
export const useLazyGetChartById = (): {
  loading: boolean;
  error: boolean;
  fetchChart: (chartId: number) => Promise<SavedChart>;
} => {
  const { loading, error, fetchCallback }: LazyFetchChart = useLazyFetchV2(
    "GET"
  );

  return {
    loading,
    error,
    fetchChart: chartId => fetchCallback(`charts/${chartId}`)
  };
};
